import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import BoostIcon from '@wix/da-ds/pkg/Icons/24x24/Boost';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import BoostRootModal from './modals/BoostRootModal';
const BoostButton = ({ deviation, className })=>{
    var _deviation_extended;
    const { t } = useTranslation();
    const isBoosterEnabled = useFlag('booster');
    const [isShowingModal, setShowingModal] = useState(false);
    const showModal = ()=>setShowingModal(true);
    const closeModal = ()=>setShowingModal(false);
    if (!isBoosterEnabled) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className,
        tooltip: t(((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.boosted) ? 'actionbar.currentlyBoosted' : 'actionbar.boost')
    }, /*#__PURE__*/ React.createElement(IconButton, {
        disabled: deviation.boosted,
        size: "medium",
        icon: BoostIcon,
        onClick: showModal
    })), isShowingModal && /*#__PURE__*/ React.createElement(BoostRootModal, {
        deviation: deviation,
        onRequestClose: closeModal
    }));
};
BoostButton.displayName = 'BoostButton';
export default BoostButton;

//# sourceMappingURL=BoostButton.js.map